// extracted by mini-css-extract-plugin
export default {"timeline-item__text":"styles_timeline-item__text__63-4w","timeline-item__date-range":"styles_timeline-item__date-range__HvqCM"};